export const COUNTRIES = "COUNTRIES";
export const STATES = "STATES";
export const CITIES = "CITIES";

export default {
  COUNTRIES,
  STATES,
  CITIES
};
